import { QUESTION_SET_CURRENT } from '../actions'

function CurrentIntroQuestionsReducer(state = 0, action) {
    switch (action.type) {
        case QUESTION_SET_CURRENT:
            return action.payload
        default:
            return state
    }
}

export default CurrentIntroQuestionsReducer



// WEBPACK FOOTER //
// ./src/reducers/currentIntroQuestion.js